import styled from 'styled-components';
import palette from '@mlc/mlc-palette';

export const Tile = styled.div`
	background-color: ${palette.mlcCore};
	padding: 1em;
`;
